import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Subscription from './../subscription/Subscription';
import DialogBase from './DialogBase';
import { DialogContent, DialogTitle } from '@mui/material';

class DialogSubscription extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-subscription";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Formule Premium</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <Subscription
            scrollableTarget={scrollableTargetId}
            fixedCtrl={true}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogSubscription.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogSubscription);
